import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useToast } from "../other/Toast";
import { classNames } from "primereact/utils";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router";
import SecurityService from "../service/SecurityService";
import { Tag } from 'primereact/tag'
import { Password } from "primereact/password";
import { Dialog } from "primereact/dialog";
import apiService from "../service/apiService";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";
import { useDispatch } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog";
import kycSaveApiService from "../service/kycSaveApiService";
const logo = require('../../cdsc-Blue-Logo.png');

const ChangeDp = ({ setShowModal }) => {

  const toast = useToast();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [organizationList, setOrganizationList] = useState([]);
  const [dpId, setDpId] = useState();

  const history = useHistory();
  const labelTemplate = (options) => {
    return options.dpId === null ? options.name : options.name + "-" + options.dpId;
  }

  useEffect(() => {
    apiService.getDpList().then((response) => {
      setOrganizationList(response.data.data);
    });
  }, []);

  const accept = () => {
    if (dpId)
      kycSaveApiService.changeDp(dpId)
        .then((response) => {
          toast.success("Successfully changed KYC Agent.");
          setShowModal(false);
        })
        .catch((e) => {
          toast.error("Unsuccessful", e.response && e.response.data && (e.response.data.message || e.response.data.msg));
        });
    else
      toast.warning("Unsuccessful", "KYC Agent not selected.");

  }
  const displayConfirmModal = () => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept,
    });
  };
  return (
    <Dialog
      header="Change KYC Agent"
      visible={true}
      style={{ width: "40%", height: "550px" }}
      // footer={renderFooter}
      // onMaskClick={(e) => {
      //   console.log('mask click', e.target.className);
      //   if (e.target.className.includes("mask") && !((slotList && slotList.length > 0)))
      //     setVideoSessionModal(false);
      // }}
      onHide={() => {
        setShowModal(false);
      }}
    >

      <div className="p-field p-col-12 p-md-12 stick-right stick-left">
        <label className="p-col-12 p-md-12" htmlFor="forwardToDp">
          {t("forwardToDp")}*
        </label>

        <Dropdown
          value={dpId}
          filter showClear
          dropdownIcon={'pi pi-chevron-down'}
          onChange={(e) => {
            setDpId(e.target.value);
          }}
          options={organizationList}
          optionLabel={labelTemplate}
          placeholder={t("selectDp")}
          optionValue="dpId"
        />
      </div>

      <Button
        className="p-button-secondary button-save"
        label={"Change KYC Agent"}
        onClick={displayConfirmModal}
        style={{ margin: 5, flex: 1, width: 'unset' }}
      />
    </Dialog>
  )
}

export default ChangeDp;